<template>
    <div id="paperdevicegroup">
        <!-- {{PlugJson}} -->
    </div>
</template>

<script>
export default {
    name:'paperdevicegroup'
}
</script>

<style scoped>

</style>